<template>
    <nav class="navigation-info fs-17 text-color-muted">
        <ol class="list list-inline flex flex-space-35">
            <li
                v-for="(item, i) in items"
                :key="i"
                :class="{ 'is-active': i === currentIndex }"
            >
                <span v-text="item" />
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            items: [
                'Zaloguj się',
                'Sprawdź dane i wyraź zgodę'
            ],
            currentIndex: 0
        }
    },

    computed: {
        currentStep() {
            return this.$store.getters['steps/step']
        }
    },

    watch: {
        currentStep: {
            handler(value) {
                this.currentIndex = this.mapStepName(value)
            }
        }
    },

    methods: {
        mapStepName(step) {
            const outMap = {
                'entry': 0,
                'consents': 1,
                'coupon': 2
            }

            if (!outMap.hasOwnProperty(step)) {
                console.warn(`[NavigationInfo] No item associated with step name ${step}.`)

                return 0
            }

            return outMap[step]
        }
    }
}
</script>

<style lang="scss">
.navigation-info {
    height: 100%;

    > ol {
        counter-reset: item;
        height: 100%;

        > li {
            @include transition(.150s);
            position: relative;
            padding: 0 12px 0 33px;

            &:before {
                content: counter(item);
                counter-increment: item;
                @include size(24px);
                @include border-circle();
                background-color: $color-bg-dark;
                text-align: center;
                position: absolute;
                top: 0;
                left: 0;
                font-size: 1.3rem;
                line-height: 2.3rem;
            }

            &:after {
                content: '';
                @include transform-origin(100%, 0);
                @include transform(scaleX(0));
                @include transition(transform .250s ease-in-out, opacity .250s ease-in-out);
                background-color: $color-secondary;
                position: absolute;
                left: 0;
                right: 0;
                bottom: -34px;
                height: 4px;
                opacity: .618;
            }

            &.is-active {
                color: $color-default;

                &:before {
                    background-color: $color-secondary;
                }

                &:after {
                    @include transform-origin(0, 0);
                    @include transform-none();
                    opacity: 1;
                }
            }
        }
    }

    @media (max-width: $screen-page-large) {
        > ol {
            &.flex-space-35 {
                > li {
                    margin-left: 5px;
                }
            }
        }
    }

    @media (max-width: $screen-laptop) {
        > ol {
            > li {
                &:not(.is-active) {
                    &:before {
                        top: -11px;
                    }

                    > span {
                        display: none;
                    }
                }
            }

            &.flex-space-35 {
                > li {
                    margin-left: 15px;
                }
            }
        }
    }

    @media (max-width: $screen-tablet) {
        > ol {
            > li {
                &:before {
                    top: -11px;
                }

                &:after {
                    display: none;
                }

                > span {
                    display: none;
                }
            }

            &.flex-space-35 {
                > li {
                    margin-left: -15px;
                }
            }
        }
    }

    @media (max-width: $screen-mobile-large) {
        > ol {
            &.flex-space-35 {
                > li {
                    margin-left: -15px;
                }
            }
        }
    }
}
</style>